export const GROUP = {
  PADDING: 30,
  HEADER: 28,
  BOUNDARY_NODE_WIDTH: 140,
} as const;
